import {
  Alert,
  Button,
  CircularProgress,
  DialogActions,
  DialogContent,
} from "@mui/material";
import ResponsiveDialog from "../UI/ResponsiveDialog";
import { useMutation } from "@apollo/client";
import { REGISTER_PLAYER, GET_CURRENT_PLAYER } from "../../GraphQL/Players";
import useNotification from "../../hooks/useNotification.js";

const RegisterPlayerDialog = (props) => {
  const { notifySuccess } = useNotification();

  const [registerPlayer, { loading, error }] = useMutation(REGISTER_PLAYER, {
    refetchQueries: [GET_CURRENT_PLAYER],
    onCompleted: () => { notifySuccess("Registered as player."); props.setOpen(false); },
  });

  return (
    <div>
      <ResponsiveDialog
        open={props.open}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            registerPlayer();
          } else if (e.key === "Escape") {
            props.setOpen(false);
          }
        }}
        title="Register as Player"
        onClose={() => props.setOpen(false)}
      >
        <DialogContent>Player</DialogContent>
        {error && (
          <Alert severity="error" sx={{ mx: 2, mb: 1 }}>
            {error.message}
          </Alert>
        )}
        <DialogActions>
          <Button
            data-testid="saveRegisterPlayerDialogButton"
            variant="contained"
            onClick={() => registerPlayer()}
            disabled={loading}
          >
            {loading ? (
              <CircularProgress size={20} sx={{ color: "inherit" }} />
            ) : (
              "Register as Player"
            )}
          </Button>
          <Button
            data-testid="closeRegisterPlayerDialogButton"
            onClick={() => props.setOpen(false)}
          >
            Cancel
          </Button>
        </DialogActions>
      </ResponsiveDialog>
    </div>
  );
};

export default RegisterPlayerDialog;
